import { api } from './client.js';

/** 원본 lottery_order_stat_kr.php / randombox_order_stat.php 의 자료. */
export type StatKind = 'lottery' | 'randombox';

export interface DailyPoint {
  id: string;
  day: string;
  tickets: number;
}

export interface MonthlyRow {
  id: string;
  name: string | null;
  saleEnd: string | null;
  ym: string;
  tickets: number;
  sales: number;
}

export interface StatResult {
  kind: StatKind;
  from: string;
  to: string;
  months: string[];
  daily: DailyPoint[];
  monthly: MonthlyRow[];
}

/**
 * 원본 lottery_order_stat_list_kr.php. lottery(F주문통계(상세)) 전용이다 -
 * randombox 판(N주문통계(상세))은 메뉴·화면과 함께 없앴다.
 */
export interface MonthDetail {
  kind: 'lottery';
  month: string;
  daily: { day: string; sales: number; tickets: number }[];
  byBox: { id: string; name: string | null; sales: number; tickets: number }[];
}

/** 원본 randombox_order_randombox.php */
export interface BoxReportRow {
  day: string | null;
  firstOrder: string | null;
  lastOrder: string | null;
  uuCount: number;
  tickets: number;
  ticketsUnder50: number;
  tickets50: number;
  sales: number;
  delivery: number;
}

export interface BoxReport {
  kind: StatKind;
  id: string;
  name: string | null;
  rows: BoxReportRow[];
  total: BoxReportRow | null;
}

export interface BoxOption {
  id: string;
  name: string;
  kind: 'lottery' | 'fanza' | 'randombox';
}

export const statsApi = {
  boxes: (kind: StatKind) => api.get<BoxOption[]>(`/stats/${kind}/boxes`),
  load: (kind: StatKind, from: string, to: string) =>
    api.get<StatResult>(`/stats/${kind}?from=${from}&to=${to}`),
  month: (kind: 'lottery', month: string) =>
    api.get<MonthDetail>(`/stats/${kind}/month?month=${month}`),
  box: (kind: StatKind, id: string) =>
    api.get<BoxReport>(`/stats/${kind}/box/${encodeURIComponent(id)}`),
};
